/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, jsx-a11y/no-noninteractive-element-interactions */
import React from 'react'
import { withTranslation } from 'react-i18next'

import './LessonPlanCardPopover.scss'

class LessonPlanCardPopover extends React.Component {
  UNSAFE_componentWillMount() {
    document.addEventListener('click', this._handleClick, false)
  }
  componentWillUnmount() {
    document.removeEventListener('click', this._handleClick, false)
  }
  render() {
    const { is_draft, duplicate, id, isMine, t } = this.props
    return (
      <div
        id='LessonPlanCardPopover'
        ref={node => (this.node = node)}
        onClick={this._anotherClick}
      >
        <p onClick={duplicate}>
          {t(is_draft ? 'lessonPlans.cardPopover.duplicateDraft' : 'lessonPlans.cardPopover.duplicatePlan')}
        </p>
        <p
          className={isMine ? '' : 'inactive'}
          onClick={e => this._handleEditClick(e)}
        >
          {t(is_draft ? 'lessonPlans.cardPopover.editDraft' : 'lessonPlans.cardPopover.editPlan')}
        </p>
        <p
          className={`delete-lp ${isMine ? '' : 'inactive'}`}
          onClick={() => this._handleDeleteClick(id)}
        >
          {t(is_draft ? 'lessonPlans.cardPopover.deleteDraft' : 'lessonPlans.cardPopover.deletePlan')}
        </p>
      </div>
    )
  }

  _handleEditClick = e => {
    const { edit, isMine } = this.props
    if (isMine) {
      edit(e)
    }
  }

  _handleDeleteClick = id => {
    const { deleteLP, isMine } = this.props
    if (isMine) {
      deleteLP(id)
    }
  }

  _handleClick = e => {
    // just tracks if the user clicks outside the component to close the popover
    if (!this.node.contains(e.target)) {
      this.props.close()
    }
  }

  _anotherClick = e => {
    // stops from click event on whitespace of component selecting this session to display on the page
    e.stopPropagation()
  }
}

export default withTranslation()(LessonPlanCardPopover)
